import { useEffect } from 'react';

import { redirectTo } from '#/lib/redirect';

import { useIsMobile } from './useIsMobile';

export default function useRedirectNonMobile(to: string) {
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!isMobile) {
      redirectTo(to);
    }
  }, [isMobile, to]);
}
